import React, { useEffect, useState } from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { InfoOutlined } from '@material-ui/icons';
import classes from '../IconButtons.module.css';

/**
 * An icon that stays open as long as you hover over it. On mobile,
 * it will open on click and close when clicked outside.
 * @param {{ title: Object, text: Object }} popoverContent - The content to display in popover as an object composed of a title and text field.
 * @param {number} [hoverDuration=500] - Duration (in ms) to delay before closing the popover.
 * @param {React.ReactElement} [icon] - Custom icon component to display as the button.
 * @param {string} [direction='bottom'] where the popover starts from. Bottom means the popover will base itself from the bottom of the icon div
 * @constructor
 */
export default function IconWithHover({ popoverContent, hoverDuration = 500, icon, direction = 'bottom' }) {
    const [open, setOpen] = useState(false);
    const [timeoutId, setTimeoutId] = useState(null);

    // Cancel any lingering timeout when the component unmounts
    useEffect(() => {
        return () => {
            if (timeoutId) clearTimeout(timeoutId);
        };
    }, [timeoutId]);

    function handleMouseLeave() {
        const id = setTimeout(() => setOpen(false), hoverDuration);
        setTimeoutId(id);
    }

    function handleMouseEnter() {
        setOpen(true);
        if (timeoutId) {
            clearTimeout(timeoutId);
            setTimeoutId(null);
        }
    }

    // Clone the icon element to apply the event handlers
    const iconElement = React.cloneElement(
        icon || <InfoOutlined className={classes.InfoIcon} />,
        {
            onClick: handleMouseEnter,
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave,
            className: `${icon ? '' : classes.InfoIcon} ${icon?.props?.className || ''}`.trim(), //apply InfoIcon.css if icon not provided
        }
    );

    let content = iconElement;

    if (popoverContent) {
        content = (
            <OverlayTrigger
                placement={direction}
                rootClose
                show={open}
                overlay={
                    <Popover
                        id="pattern-game-description"
                        onMouseLeave={handleMouseLeave}
                        onMouseEnter={handleMouseEnter}
                        onMouseOver={handleMouseEnter}
                    >
                        <Popover.Title style={{ textAlign: 'center' }}>
                            {popoverContent?.title || ''}</Popover.Title>
                        <Popover.Content className="game-description">
                            {popoverContent?.text || ''}
                        </Popover.Content>
                    </Popover>
                }
            >
                {iconElement}
            </OverlayTrigger>
        );
    }


    return content;
}